import * as React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { FeedbackForm } from './feedbackform'
import { ChatButton } from './chatbutton'
import { userIdFromAnswersHubSelector, hubSelector } from '../../selectors/hub'
import {
  currentAnswersArticleFromParamsDetailsSelector
 } from '../../selectors/articleDetails'
import { HubItem } from '../../reducers/hub'

import '../../sass/answers/feedbackalternatives.scss'
import { RootState } from '../../types/rootstate'

interface StateProps {
  userId: number
  article: RootState['articleDetails']['key']['article']
  hub: HubItem[]
}

interface DispatchProps {
}

interface OwnProps {
  hasLoaded?: () => void
}

type FeedbackAlternativesProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    userId: userIdFromAnswersHubSelector(state),
    article: currentAnswersArticleFromParamsDetailsSelector(state) as RootState['articleDetails']['key']['article'],
    hub: hubSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
  }
}

interface FeedbackAlternativesState {
  showEmailForm: boolean
  hasOnlineHubItem: boolean
}

const FeedbackFormAlternative = ({subject, body, onClick}: {subject: string, body: string, onClick?: Function}) => {
  const subjectHtml = {
    __html: subject
  }

  const bodyHtml = {
    __html: body
  }

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    onClick && onClick()
  }

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick && onClick()
    }
  }

  return <div className="col-xs-12">
    <div
      className={'chatbutton accentSecondaryButton'}
      onClick={handleOnClick}
      role='button'
      tabIndex={0}
      onKeyDown={handleOnKeyDown}>
        <div dangerouslySetInnerHTML={subjectHtml} />
        <div dangerouslySetInnerHTML={bodyHtml} />
    </div>
  </div>
}


class FeedbackAlternativesComponent extends React.Component<FeedbackAlternativesProps, FeedbackAlternativesState> {
  constructor (props) {
    super(props)

    this.state = {
      showEmailForm: false,
      hasOnlineHubItem: this.props.hub && this.props.hub.some((hubItem) => hubItem.type === 'online')
    }
  }

  componentDidMount () {
    const showChatAlternative = !!this.props.article.wasHelpfulChatForm
    const showPhoneAlternative = !!this.props.article.wasHelpfulPhoneForm

    if (!showChatAlternative && !showPhoneAlternative && !this.state.showEmailForm) {
      // Nothing
    } else {
      window.setTimeout(() => {
        this.props.hasLoaded && this.props.hasLoaded()
      })
    }
  }

  handleEmailFormClick = () => {
    this.setState({
      showEmailForm: true
    })
  }

  render () {
    const showChatAlternative = !!this.props.article.wasHelpfulChatForm && this.state.hasOnlineHubItem
    const showPhoneAlternative = !!this.props.article.wasHelpfulPhoneForm

    let showEmailAlternative = !!this.props.article.wasHelpfulEmailForm
    let showEmailForm = this.state.showEmailForm
    const hasEmailForm = this.props.article.contactEmailId

    if (!showChatAlternative && !showPhoneAlternative && !showEmailForm && hasEmailForm) {
      showEmailForm = true
      showEmailAlternative = false
    }

    return (
      <div className='feedbackAlternatives'>
        {showChatAlternative && <ChatButton text={this.props.article.contactChatSubject} />}

        {showPhoneAlternative && <FeedbackFormAlternative
          subject={this.props.article.contactPhoneSubject}
          body={this.props.article.contactPhoneBody}
        />}

        {showEmailAlternative && <FeedbackFormAlternative
          subject={this.props.article.contactEmailSubject}
          body={this.props.article.contactEmailBody}
          onClick={this.handleEmailFormClick}
        />}
        {showEmailForm &&
          <FeedbackForm
            hasLoaded={this.props.hasLoaded}
            userId={this.props.userId}
            formId={this.props.article.contactEmailId}
            articleId={this.props.article.id} />
        }
      </div>
    )
  }
}

const FeedbackAlternatives = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(FeedbackAlternativesComponent)

export {
  FeedbackAlternatives
}
